export default __webpack_public_path__ + "static/media/accounting_point_2.e2aab628.png";